var Pastebin = require('pastebin');


var PastebinList = Backbone.Collection.extend({
    model: Pastebin,
    initialize: function (models, options) {
        this.session = options.session;
    },
    comparator: function (pastebin) {
        return -pastebin.get('date');
    },
    getPages: function () {
        if (this.total) {
            return Math.ceil(this.total/this.per_page);
        }
    },
    fetch: function (page) {
        var data = {};
        if (page > 1) {
            data.page = page;
        }
        if (this.fetchComplete) {
            this.fetchComplete.reject();
        }
        var complete = this.session.getBackoff('pastebins', data);
        this.fetchComplete = complete;
        return complete.promise().done(_.bind(function (response) {
            this.total = response.total;
            this.per_page = response.per_page;
            this.page = response.page;
            this.set(response.pastebins, {
                session: this.session
            });
            this.trigger('fetched');
        }, this));
    }
});


module.exports = PastebinList;



//////////////////
// WEBPACK FOOTER
// ./app/src/collection/pastebinlist.js
// module id = ZRaQ
// module chunks = 1